export default __webpack_public_path__ + "static/media/screenshot-billing-view.3e2dbfe6.png";